export interface CategoryMeta {
  key: string;
  name: string;
  enName: string;
  desc: string;
  icon: string;
}

export const categoryMetaList: CategoryMeta[] = [
  {
    key: "movie",
    name: "电影",
    enName: "Movies",
    desc: "精选院线与口碑佳作，覆盖剧情、悬疑、科幻、动画等多元题材，帮你快速找到想看的电影。",
    icon: "ri-film-line",
  },
  {
    key: "tv",
    name: "电视剧",
    enName: "TV Series",
    desc: "汇集都市、古装、悬疑、治愈等热播剧集，追更与补番都能在这里找到方向。",
    icon: "ri-tv-2-line",
  },
  {
    key: "star-news",
    name: "明星动态",
    enName: "Star News",
    desc: "聚焦明星采访、活动现场与片场花絮，第一时间了解台前幕后的新鲜故事。",
    icon: "ri-user-star-line",
  },
];

export const genreOptions = [
  "剧情",
  "悬疑",
  "犯罪",
  "科幻",
  "爱情",
  "喜剧",
  "动作",
  "古装",
  "历史",
  "家庭",
  "都市",
  "青春",
  "冒险",
  "励志",
  "奇幻",
  "职场",
  "治愈",
  "医疗",
  "战争",
  "运动",
];

export const regionOptions = [
  "中国大陆",
  "中国香港",
  "韩国",
  "日本",
  "美国",
  "英国",
  "法国",
];

export const yearOptions = [2024, 2023, 2022, 2021];

export const popularityOptions = ["热门", "口碑佳作", "新上线"];

export const starTagOptions = ["采访", "活动", "片场", "花絮", "绯闻"];